<div *ngIf="showButtonType === 'lableBorderButton'" class="border-button-alignment" [ngClass]="httpService.theme">
    <div *ngFor="let label of labelArray; let i = index">
        <div class='btn-border' (click)="selectLabelBorderButton(i)">
            <div class="label-border-button" [ngClass]="selectedLabelBorderButton ===  i ? 'selected-button' : ''"
                id="my-button" name="button" [ngStyle]="{'padding': padding,  'width': buttonWidth}">{{label}}</div>
            <div class="border-button" [ngClass]="selectedLabelBorderButton === i ? 'border-button-selected' : ''">
            </div>
        </div>
    </div>
</div>